export default class Globals {}

//Upload
Globals.API_MaxAllowedFileSize = 157286400; //15MB

//Enums
Globals.ApplicationTypes = {
  NEW: 'NEW',
  RENEWAL: 'RENEWAL',
};